<template>
  <v-form-create
    v-if="access.create_good_category"
    name="category"
    top_title="create_category"
  >
    <v-form v-model="is_valid">
      <v-text-field
        v-model="current_category_obj.name"
        ref="name"
        :rules="[fieldRules.required]"
        :label="$t('category_name')"
      />
      <v-menu offset-y v-bind:close-on-content-click="false">
        <template #activator="{ on }">
          <v-text-field
            readonly
            v-on="on"
            v-model="current_category_obj.category.name"
          />
        </template>
        <v-card max-height="200" class="overflow-y-auto">
          <v-treeview
            dense
            activatable
            item-key="_id"
            v-bind:items="top_categories"
            :load-children="fetchCategories"
            v-on:update:active="activate"
          />
        </v-card>
      </v-menu>
    </v-form>
    <br />

    <v-card-title class="title-2">{{ $t("stores") }}</v-card-title>
    <v-list class="mx-2">
      <v-list-item
        v-for="(service, index) in current_category_obj.services"
        v-bind:key="index"
      >
        <v-list-item-content>
          <v-list-item-title>{{ service.service_name }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch v-model="service.available" />
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <v-card-title class="title-2">
      {{ $t("show_on_bot") }}
      <v-spacer />
      <v-switch v-model="current_category_obj.show_on_bot" />
    </v-card-title>

    <v-autocomplete
      class="mx-4"
      v-if="current_category_obj.show_on_bot"
      multiple
      v-model="current_category_obj.show_on_bot_services"
      :items="services"
      item-text="name"
      item-value="_id"
      :label="$t('show_on_bot_services')"
    />

    <v-radio-group row v-model="current_category_obj.present_type">
      <v-radio :label="$t('color')" value="color" />
      <v-radio :label="$t('image')" value="image" />
    </v-radio-group>
    <v-hover
      v-if="current_category_obj.present_type == 'image'"
      #default="{ hover }"
    >
      <v-card
        width="150"
        height="130"
        outlined
        class="text-center"
        :loading="upload_image"
        :class="
          current_category_obj.image != '' ? 'pa-0' : hover ? 'py-10' : 'pa-10'
        "
      >
        <v-icon v-if="current_category_obj.image == ''" x-large>
          mdi-image-size-select-actual
        </v-icon>
        <v-img
          height="125"
          v-else
          class="ma-0"
          :src="current_category_obj ? current_category_obj.image : ''"
        />
        <v-expand-transition>
          <div
            v-if="hover"
            class="d-flex transition-fast-in-fast-out v-card--reveal pointer"
          >
            <v-card
              block
              color="primary"
              dark
              tile
              class="d-flex transition-fast-in-fast-out v-card--reveal pointer"
            >
              <label class="file-select pointer py-1" style="width: 100%">
                Upload
                <input
                  type="file"
                  accept="image/*"
                  style="display: none"
                  @change="uploadClicked"
                />
              </label>
            </v-card>
          </div>
        </v-expand-transition>
      </v-card>
    </v-hover>
    <v-color-group v-else v-model="current_category_obj.color" />
    <template #action>
      <v-btn text @click="cancelClicked">{{ $t("cancel") }}</v-btn>
      <v-btn text color="primary" v-on:click="save" :disabled="saveDisabled">
        {{ $t(target) }}
      </v-btn>
    </template>
  </v-form-create>
  <error404 v-else></error404>
</template>
<script>
import Categories from "../../mixins/items/categories";
import Services from "../../mixins/services";

export default {
  name: "ItemsCategoriesCreate",
  mixins: [Categories, Services],
  data: () => ({
    active: "top",
    params: {
      name: null,
      category: {
        _id: "top",
        name: "Top",
      },
      color: "#E0E0E0",
    },
    map: {},
    is_valid: false,
    upload_image: false,
  }),
  methods: {
    cancelClicked() {
      this.$router.push({ path: "/items/categories" });
    },

    async uploadClicked(e) {
      this.upload_image = true;
      if (e && e.target && e.target.files && e.target.files[0]) {
        this.image_loading = true;
        try {
          var res = await this.$communicator.file(
            "upload",
            {
              file: e.target.files[0],
            },
            true
          );
          this.current_category_obj.image =
            `${this.$communicator.base_url}static/` + res.data.data.path;
          this.upload_image = false;
        } catch (err) {
          this.upload_image = false;
          throw err;
        }
      }
    },
    async save() {
      var current_category_obj = this.$copy(this.current_category_obj);
      delete current_category_obj.category;
      current_category_obj.type = JSON.parse(JSON.stringify(this.active));
      if (this.target == "create") {
        await this.$communicator("create_category", {
          params: current_category_obj,
        });
        this.$toast.success("Success", { timeout: 2000 });
      } else {
        await this.$communicator("update_category", {
          arguments: [this.$route.query["id"]],
          params: current_category_obj,
        });
        this.$toast.success("Success", { timeout: 2000 });
      }
      this.$router.push({ path: "/items/categories" });
    },
    activate(items) {
      if (items.length > 0) {
        this.active = items[items.length - 1];
        if (!this.map[this.active]) {
          for (const categ of this.all_plus_children_categories) {
            if (categ._id == this.active) {
              this.map[this.active] = {
                id: categ._id,
                name: categ.name,
                type: categ.type,
              };
            }
          }
        }
        if (this.map[this.active]) {
          this.current_category_obj.category.name = this.map[this.active].name;
        }
      }
    },
    route(categories) {
      for (const index in categories) {
        this.map[categories[index]._id] = {
          id: categories[index]._id,
          name: categories[index].name,
          type: categories[index].type,
        };
        if (
          categories[index].children &&
          categories[index].children.length > 0
        ) {
          this.route(categories[index].children);
        }
      }
    },
    async refresh() {
      if (this.target == "update") {
        const id = this.$route.query["id"];
        if (this.map[id]) {
          this.current_category_obj.name = this.map[id].name;
          this.current_category_obj.edit_index = id;
          if (this.map[this.map[id].type]) {
            this.active = this.map[this.map[id].type].type;
            this.current_category_obj.category.name =
              this.map[this.map[id].type].name;
          }
        }
      }
    },
  },
  async mounted() {
    this.categorySortedByPosition();
    if (this.target == "update") {
      await this.getCurrentCategory(this.$route.query["id"]);
    }
    this.refresh();
    this.route(this.top_categories);
  },
  computed: {
    target() {
      return this.$route.params["target"];
    },
    form() {
      return {
        name: this.current_category_obj.name,
      };
    },
    saveDisabled() {
      let formHasErrors = false || !this.is_valid;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
  },
  watch: {
    top_categories() {
      this.route(this.top_categories);
      this.refresh();
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>

<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
}
.file-select > .select-button {
  padding: 1rem;

  color: white;
  background-color: #2ea169;

  border-radius: 0.3rem;

  text-align: center;
  font-weight: bold;
}
.file-select > input[type="file"] {
  display: none;
}
.pointer {
  cursor: pointer;
}
</style>
